import styled from 'styled-components';
import { breakpoint, spacing } from '@carvana/ds-styles';

const PlateState = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: ${spacing.md};
  margin-top: 0;

  @media screen and (min-width: ${breakpoint.sm}) {
    margin-top: ${spacing.lg};
  }
`;

const PlateTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const Wrapper = styled.div`
  flex: 0 0 auto;
  width: 110px;
  text-align: left;
`;

export { PlateState, PlateTextWrapper, Wrapper };
